import React, { useState } from "react";
import { useHistory } from "react-router";
import { Form, Label, Button, InputGroup, FormControl } from "react-bootstrap";
import logoIcon from "../../assets/images/logo-full.svg";
import { NavLink } from "react-router-dom";
import { useForm } from "react-hook-form";
import { EmptyLocalStorage, Login } from "../../services/auth/auth.service";
import { constants } from "../../utils/constants";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Select from "react-select";

function Signin() {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const [pass, TogglePass] = useState(true);
  const [rememberMe, setRememberMe] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  // const onSubmit = async (data) => {
  //   setIsLoading(true);
  //   try {
  //     const res = await Login(
  //       data.email,
  //       data.password,
  //       data.role_id,
  //       "web",
  //       "xyz",
  //       rememberMe
  //     ).then((data) => {
  //       if (data.success) {
  //         console.log(data + "Hello");
  //         toast.success(data.message);
  //         history.push("/dashboard");
  //       } else {
  //         toast.error(data.message);
  //       }
  //     });
  //   } catch (error) {
  //     console.log(error.response.data + "Hello");
  //     setIsLoading(false);
  //     if (error.response.status == 401) {
  //       EmptyLocalStorage();
  //       history.push("/");
  //     } else {
  //       return toast.error(error.response.data.message);
  //     }
  //   }
  // };

  const onSubmit = async (data) => {
    setIsLoading(true);
    await Login(
      data.email,
      data.password,
      data.role_id,
      "web",
      "xyz",
      rememberMe
    )
      .then((data) => {
        if (data.success) {
          toast.success(data.message);
          history.push("/dashboard");
        } else {
          toast.error(data.message);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response.status == 401) {
          EmptyLocalStorage();
          history.push("/");
        } else {
          return toast.error(error.response.data.message);
        }
      });
  };

  // console.log(watch(errors.message)) //width={"164px"}
  return (
    <div className={"text-center authLayout"}>
      <Form className={"form-signin"} onSubmit={handleSubmit(onSubmit)}>
        <a href="/">
          <img
            className="img-fluid mb-4"
            src={logoIcon}
            alt="Imprint Logo"
            title="Imprint Logo"
            style={{ padding: "10px 25px" }}
          />
        </a>
        <h1 className="h5 mb-3 font-weight-normal">Sign In</h1>
        <Form.Group className="mb-3">
          <Form.Control
            placeholder="Enter Email"
            id={"formSignInEmail"}
            {...register("email", {
              required: {
                value: "required",
                message: "Email is required",
              },
              maxLength: {
                value: 255,
                message: "Max length is 255",
              },
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: "Entered value does not match email format",
              },
            })}
            type="email"
          />
          {errors.email && (
            <span className={"validation-error pr-5"} role="alert">
              {errors.email.message}
            </span>
          )}

          {/*password*/}
          <div className={"pass-field"}>
            <InputGroup controlId="passowrd">
              <FormControl
                placeholder="Enter Password"
                autoComplete={"off"}
                {...register("password", {
                  minLength: {
                    value: 8,
                    message: "Min length is 8",
                  },
                  maxLength: {
                    value: 255,
                    message: "Incorrect Password",
                  },
                })}
                type={pass ? "password" : "text"}
              />
              <Button
                variant="outline-secondary"
                id="button-addon2"
                onClick={() => TogglePass(!pass)}
              >
                {pass ? <FaEye /> : <FaEyeSlash />}
              </Button>
            </InputGroup>
            {errors.password && (
              <span className={"validation-error pr-5"} role="alert">
                {errors.password.message}
              </span>
            )}
          </div>
          {/*password*/}

          {/*<Form.Control*/}
          {/*    placeholder="Password"*/}
          {/*    id={"formSignInPassword"}*/}
          {/*    {...register('password', {*/}
          {/*        required: {*/}
          {/*            value: "required",*/}
          {/*            message: "Password is required"*/}
          {/*        },*/}
          {/*        minLength: {*/}
          {/*            value: 8,*/}
          {/*            message: "Min length is 8"*/}
          {/*        },*/}
          {/*        maxLength: {*/}
          {/*            value: 255,*/}
          {/*            message: "Max length is 255"*/}
          {/*        }*/}
          {/*    })}*/}
          {/*    type="password"*/}
          {/*/>*/}
          {/*{errors.password &&*/}
          {/*<span className={"validation-error"} role="alert">{errors.password.message}</span>}*/}
          <Form.Control
            placeholder="Select Role"
            id={"roleId"}
            {...register("role_id", {
              required: {
                value: "required",
                message: "Role is required",
              },
            })}
            as="select"
            className="roleDropdown"
          >
            <option selected disabled value="">Login as</option>
            <option value={constants.ROLES.ROLE_ADMIN}>Admin</option>
            <option value={constants.ROLES.RESTAURANT_OWNER}>Business</option>
          </Form.Control>
          {errors.role_id && (
            <span className={"validation-error"} role="alert">
              {errors.role_id.message}
            </span>
          )}
        </Form.Group>

        <Form.Group className="mb-3 checkbox" controlId="formBasicCheckbox">
          <Form.Check type="checkbox" label="Remember me" />
        </Form.Group>
        <div className="d-grid gap-2">
          <Button
            variant="primary"
            size="lg"
            type="submit"
            className={"btn-green-theme"}
            disabled={isLoading}
          >
            Submit
          </Button>
          <ul className={"list-inline mt-3 d-flex"}>
            <li className={"list-inline-item text-left"}>
              <NavLink to={"/forgot-password"}>Forgot Password</NavLink>
            </li>
            {/*<li className={"list-inline-item text-right ms-auto"}>
                                <NavLink to={"/sign-up"}>
                                    Sign Up
                                </NavLink>
                            </li>*/}
          </ul>
        </div>
        <p className="mt-5 mb-3 text-muted">
          &copy; All rights reserved by Tekrevol 2022
        </p>
      </Form>
    </div>
  );
}

export default Signin;
